import React, { useContext } from 'react';
import classnames from 'classnames';
import { LoveSlider } from '../../../LoveMeter';
import { MobileContext } from '../../../Context';
import statStyles from '../StatLayout/Stat.scss';
import s from './LoveMeter.scss';
export var LoveMeter = function (_a) {
    var className = _a.className;
    var isMobile = useContext(MobileContext);
    return (React.createElement(LoveSlider, { className: classnames(s['root'], s['dammit'], className), activeIconClassName: statStyles['active'], type: "devpage", orientation: isMobile ? 'horizontal' : 'vertical', isFilled: true }));
};
LoveMeter.displayName = 'LoveMeter';
export default LoveMeter;
//# sourceMappingURL=LoveMeter.js.map